import clsx from 'clsx';
import React from 'react';
import BlueLinkIcon from '../../assets/icons/blue-link-icon.svg?react';
import Button from '../Button';
import { useNavigate } from 'react-router';
import { useButtonSizeLarge } from '../../utils/buttonSizes';

interface ErrorScreenProps {
  otherClasses?: string;
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({ otherClasses }) => {
  const errorScreenClasses = clsx(
    otherClasses,
    'w-full h-dvh flex justify-center items-center px-4',
  );
  const navigate = useNavigate();
  const buttonSize = useButtonSizeLarge();

  return (
    <div className={errorScreenClasses} data-testid="error-screen">
      <div className="mx-auto flex w-full max-w-685 flex-1 flex-col items-center gap-12">
        <BlueLinkIcon className="[&>path]:fill-brand-byzantine h-100 w-100 lg:h-150 lg:w-150" />
        <div className="flex flex-col gap-2.5 text-center">
          <h2 className={clsx('text-neutral-tones-text font-bold')}>
            Something went wrong
          </h2>
          <p className="font-inter-variable text-brand-byzantine text-2xl font-medium italic">
            Something didn't work as expected. Please try again later.
          </p>
        </div>
        <Button
          onClick={() => navigate('/dashboard')}
          otherClasses={clsx('max-w-465 w-full')}
          size={buttonSize}
        >
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default ErrorScreen;
